import { render, staticRenderFns } from "./GratitudeFOCGS.vue?vue&type=template&id=b4d0e342"
import script from "./GratitudeFOCGS.vue?vue&type=script&lang=js"
export * from "./GratitudeFOCGS.vue?vue&type=script&lang=js"
import style0 from "./GratitudeFOCGS.vue?vue&type=style&index=0&id=b4d0e342&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports